import React from 'react';
import cx from 'classnames';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import CloseIcon from '@mui/icons-material/Close';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

import css from './ModalMark.module.scss';

type TModalMark = {
  type?: 'question' | 'success' | 'error';
}

export const ModalMark = ({ type = 'question'}: TModalMark) => {
  return (
    <div className={cx(css.root, css[type])}>
      {type === 'question' && <HelpOutlineRoundedIcon className={css.icon} />}
      {type === 'success' && <CheckOutlinedIcon className={css.icon} />}
      {type === 'error' && <CloseIcon className={css.icon} />}
  </div>
  )
};
